import { WeekDay } from '@common/models/Enums';
import { defaultTo } from 'lodash';

/**
 * The backend for Hospital Schedule now returns a common base between all kinds of schedule preferneces, EntitySchedulePreference, OverrideSchedulePreference, DefaultEntitySchedulePreference, and ComputedSchedulePreference
 * They all have these fields.
 */
export class BaseEntitySchedulePreference {
  schedulePreferenceId: number;
  startTime: string;
  endTime: string;
  dayOfWeek: WeekDay.Day;
  scheduleBlockTypeId: number;
  scheduleBlockTypeColor: string;
  scheduleBlockTypeName: string;
  scheduleBlockIsOverrideType: boolean;

  constructor(init?: Partial<BaseEntitySchedulePreference>) {
    this.schedulePreferenceId = defaultTo(init?.schedulePreferenceId, 0);
    this.startTime = defaultTo(init?.startTime, '08:00:00');
    this.endTime = defaultTo(init?.endTime, '21:00:00');
    this.dayOfWeek = defaultTo(init?.dayOfWeek, WeekDay.Day.Monday);
    this.scheduleBlockTypeId = defaultTo(init?.scheduleBlockTypeId, 0);
    this.scheduleBlockTypeColor = defaultTo(
      init?.scheduleBlockTypeColor,
      '#8cdef1',
    );
    this.scheduleBlockTypeName = defaultTo(
      init?.scheduleBlockTypeName,
      'Unknown',
    );
    this.scheduleBlockIsOverrideType = defaultTo(
      init?.scheduleBlockIsOverrideType,
      false,
    );
  }
}
